import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Field, reduxForm} from 'redux-form'
import {Button, Col, Form, Modal, Row} from "react-bootstrap"
import {SelectField} from '../form/form'
import {Enums, handleResponse, Party} from "../../utils";
import {connect} from "react-redux";

const validate = (values) => {
	const errors = {};
	if (values.template && (!values.template.partyFromId && !values.template.partyToId)) {
		const m = 'Vyberte prosím subjekt';
		errors.template = {
			partyFromId: m,
			partyToId: m
		};
	}

	return errors
};

class TransactionMassUpdateForm extends Component {

	render() {
		const {
			initialValues, handleSubmit, formState, change, submitting,
			onMassUpdateTransaction,
			what, modal, enums
		} = this.props;

		const partyOptions = Enums.createEnumItems(enums, "parties", true, true);
		const partyId = formState && formState.values ? formState.values['template']['party' + what + 'Id'] : null;
		const accountOptions = Party.getPartyAccountOptions(partyId, enums);

		return <Modal onHide={modal.onHide} show={true}>
			<Modal.Header>
				<Modal.Title>Hromadně upravit {what === 'To' ? 'příjemce' : 'odesílatele'}</Modal.Title>
			</Modal.Header>

			<Form onSubmit={handleSubmit((values) => onMassUpdateTransaction(values).then((json) => handleResponse(json, modal.onSuccess)))}>
				<Modal.Body>
					<p>
						Změna proběhne pro všechny vybrané transakce ({initialValues && initialValues.items && initialValues.items.length}).
					</p>
					<Row>
						<Col xs={12}>
							<Field label={what === 'To' ? 'Příjemce' : 'Odesílatel'} name={'template[party' + what + 'Id]'} type="select" component={SelectField} sizes={[3, 9]} options={partyOptions}
								onChangeHook={(id) => Party.handlePartyChange('template[account' + what + 'Id]', id, enums, change)}/>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<Field label={false} name={'template[account' + what + 'Id]'} type="select" component={SelectField} sizes={[3, 9]} options={accountOptions}/>
						</Col>
					</Row>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button variant={"link"} onClick={modal.onHide}>Storno</Button>
							<Button variant="success" type="submit" disabled={submitting}><i className="fa fa-check"/> Změnit {what === 'To' ? 'příjemce' : 'odesílatele'}</Button>
						</Col>
					</Row>
				</Modal.Footer>
			</Form>
		</Modal>
	}
}

TransactionMassUpdateForm = reduxForm({
	form: 'transactionMassUpdate',
	validate
})(TransactionMassUpdateForm);

const mapStateToProps = (state, ownProps) => ({
	formState: state.form.transactionMassUpdate,
});

TransactionMassUpdateForm.propTypes = {
	what: PropTypes.string.isRequired,
	onMassUpdateTransaction: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	modal: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(TransactionMassUpdateForm)
